import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, cloneElement } from "react";
import { ButtonIcon } from "../../ButtonIcon/ButtonIcon.mjs";
const FieldButtonIcon = forwardRef(
  ({ label, onClick, onMouseDown, icon, ...restProps }, forwardedRef) => {
    const handleMouseDown = useCallback(
      (event) => {
        if (typeof onMouseDown !== "function") {
          return;
        }
        if (!onClick) {
          event.preventDefault();
        }
        onMouseDown(event);
      },
      [onClick, onMouseDown]
    );
    return /* @__PURE__ */ jsx(
      ButtonIcon,
      {
        ref: forwardedRef,
        label,
        icon: cloneElement(icon, { tone: icon.props.tone || "secondary" }),
        variant: "transparent",
        size: "small",
        onClick,
        onMouseDown: handleMouseDown,
        tabIndex: -1,
        ...restProps
      }
    );
  }
);
export {
  FieldButtonIcon
};
